import {
  SENTIMENT_NEGATIVE_COLOR_DARK,
  SENTIMENT_NEGATIVE_COLOR_LIGHT,
  SENTIMENT_POSITIVE_COLOR,
  useChartTheme,
} from '@revelio/replots';

export const useActivityColors = () => {
  const { theme } = useChartTheme();
  return {
    acquired: SENTIMENT_POSITIVE_COLOR,
    divested:
      theme === 'dark'
        ? SENTIMENT_NEGATIVE_COLOR_DARK
        : SENTIMENT_NEGATIVE_COLOR_LIGHT,
  };
};
